import { Icon, IconProps } from "../Icon";

const Checkmark = (props: IconProps) => (
  <Icon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 21.2L5.9 14.1L4.5 15.5L11.6 22.6L13 24L27.1 9.90002L25.7 8.40002L13 21.2Z"
      fill="currentColor"
    />
  </Icon>
);

export default Checkmark;
